export const list = [
    { name: "O nas", path: "/" },
    { name: "Makijaż\npermanentny", path: "/makijaż" },
    { name: "Kosmetologia", path: "/kosmetologia" },
    { name: "Szkolenia", path: "/szkolenia" },
    { name: "Cennik", path: "/cennik" },
    { name: "Kontakt", path: "/kontakt" },
]